import * as yup from 'yup';

export const grantsModulesSchema = yup.object({
  grantName: yup.string(),
  enabled: yup.boolean().nullable()
});
